/**
 * 模版市场tab切换工具函数
 * @author chenqunfeng
 * @since 18/06/05
 */

// path路由
export const ROUTER = {
  '/template/': 0,
  // 合并翻页、长页为展示页
  '/template/showpage.html': 1,
  // '/template/multipage.html': 1,
  // '/template/longpage.html': 2,
  '/template/shortvideo.html': 3,
  '/chajian/': 4,
  '/template/yule.html': 5,
  '/template/vip.html': 6,
  '/template/enterprise.html': 7,
  '/template/mytpl.html': 8,
  '/template/openedpage.html': 10,
  '/template/poster.html': 11,
  '/template/openedplugin.html': 12,
  '/template/openzone.html': 13, // 平台专区
};

// 获取tab对应的路由
export function getTabPath(index) {
  let path = '';
  for (const [pathname, i] of Object.entries(ROUTER)) {
    if (i === index) {
      path = pathname;
      break;
    }
  }
  return path;
}

// 通知父窗口
export function pushState(path) {
  if (window.parent && path) {
    history.pushState({}, null, path);
  }
}
